let Url = "https://smsapi.madanischoolandcollege.com/v1";
// let Url = "http://www.madani.asyncus.com/v1";
// let Url = "https://www.apis.madanischoolandcollege.com/v1";
//let Url = "";
export default Url;
